import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default class HeadingDivider extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
        <Row>
          <Col md={12}>
            <h5 style={{
              borderBottom:"1px solid #D0D0D0", 
              lineHeight: "0.1em"
            }}>
              <span style={{backgroundColor:"#fff"}}>{this.props.text}</span>
            </h5>
          </Col>
        </Row>
    );
  }
}
